import React from "react";
import styles from "./styles/hero.module.scss";

export const TermsHero = ({ title }) => {
  return (
    <section className={styles.section_terms_hero}>
      <div className="container">
        <div className={styles.title_wrapper}>
          <h1>
            <span className="mark">{title}</span>
          </h1>
          <p className={styles.sub_text}>
            Your access and use of the UniSearch website and its associated
            services (“Services”) is governed by our Terms of Service agreement
            (“Terms”). By using our website and Services, you agree to these
            Terms and are bound by the conditions within, including our policies
            on Privacy, Cookies, Intellectual Property, and User Conduct.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsHero;
